import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { environment } from 'src/environments/environment';
import {AuthService} from '../../../modules/auth';
import {BaseWebservice} from '../../../shared/base/base.webservice';
import { ProcessService } from '../../_services/process.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {Fruit} from '../share/share.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {
    @ViewChild('chipsInput') chipsInput: ElementRef<HTMLInputElement>;
  srcimage= "url('assets/media/bg/image.svg')"
  download_link = '#'
    plan: any;
  constructor(
      private authService: AuthService,
      private _globalService:BaseWebservice,
      private processService: ProcessService,
      private _cd: ChangeDetectorRef,
      private modalService: NgbModal,
      private router: Router

  ) {
    // this.processService.getWillDownloadUrl().subscribe(response => {
    //   if (response['success'] == true) {
    //     this.download_link = response['data']['url']
    //   }
    // })
  }

  ngOnInit(): void {

      this.processService.getUserDetails().subscribe(response => {
          if(response['success'] == true) {

              this.plan = +response['data'].plan  


          } else {
          }
      })


    this.processService.getWillDownloadUrl().subscribe(response => {
     
      if (response['success'] == true) {

        if(!response['data']['url'].toString().includes("https")){
            this.download_link = response['data']['url'].replace("http","https")
        }else{
            this.download_link = response['data']['url']
        }



        this._cd.detectChanges()
      }
    })
  }

  getDownloadLink() {
    return this.download_link
  }


    endSession() {
        this.authService.logout()
        this._globalService.setDataAsdefault()
    }

    openMoreCharities(content) {
        this.modalService.open(content, {centered: true, windowClass: 'modal-rounded',}).result.then((result) => {
            // this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    fruits: Fruit[] = [
    ];

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (value) {
            this.fruits.push({name: value});
        }

        // Clear the input value
        event.input.value = '';
        this.chipsInput.nativeElement.value = undefined
    }

    remove(fruit: Fruit): void {
        const index = this.fruits.indexOf(fruit);

        if (index >= 0) {
            this.fruits.splice(index, 1);
        }
    }

    closeModal() {
        this.modalService.dismissAll()
    }

    invite() {
      this.processService.sendInvite({
        recipients: this.fruits.map(v => v['name'])
      }).subscribe(res => {
        if(res['success']) {
          this.closeModal();
          this.router.navigate([`/thanks`])
        }
      })
    }

    goToDashboard(){

        window.open(
            'https://www.wisernow.com.au', '_blank' /* */);

    }
}
